<app-general-search-input
  [title]="title | translate"
  [expanded]="group.get('text')?.value"
>
  <ng-template>
    <form [formGroup]="group" class="easy-form">
      <mat-form-field>
        <app-easy-input
          formControlName="text"
          [type]="data?.type ?? 'text'"
          [maxDecimals]="data?.maxDecimals ?? 0"
          (ngModelChange)="valueChanged($event)"
        ></app-easy-input>
      </mat-form-field>
    </form>
  </ng-template>
</app-general-search-input>
